import type {Call} from '../../../store/features/calls/callsService';
import {flatDurationInMinutes} from '../../../utilis/timeUtilis';

export const AI_LIMIT_MINUTES = 15;

export const isWithinAiLimit = (call: Call | undefined): boolean => {
    if (!call) return false;
    return Boolean(
        flatDurationInMinutes(call.bridgetAt, call.finishedAt) < AI_LIMIT_MINUTES
        || flatDurationInMinutes(call.forwardedAt, call.finishedAt) < AI_LIMIT_MINUTES
        || (call.hasVoicemail && flatDurationInMinutes(call.startedAt, call.finishedAt) < AI_LIMIT_MINUTES),
    );
};

export const isRecordingDeleted = (call: Call | undefined): boolean => call?.recording?.status === 'DELETED';

export const hasRecordingAudio = (call: Call | undefined): boolean => Boolean(call?.recordingId) && !isRecordingDeleted(call);

export const isVoicemailCall = (call: Call | undefined): boolean =>
    Boolean(call?.hasVoicemail && call.type === 'INBOUND' && !call.forwardedTo);

export type InsightsBlocker = 'not_recorded' | 'deleted' | 'too_long' | null;

export const generationBlocker = (call: Call | undefined, hasTranscript: boolean): InsightsBlocker => {
    if (hasTranscript) return null;
    if (isRecordingDeleted(call)) return 'deleted';
    if (!hasRecordingAudio(call)) return 'not_recorded';
    if (!isWithinAiLimit(call)) return 'too_long';
    return null;
};
